import React, { useState, useMemo } from 'react';
import Typography from '@mui/material/Typography';
import { getLastExistingMeasurements } from '#component/device/helper';
import { Preloader } from '#component/preloader';
import { DevicesDialog } from '#component/dashboard/mobile-view/devices-dialog';
import { EventsListDialog } from '#component/shipment/overview/components/mobile-view/events-list-dialog';
import {
  CardWrapper,
  StyledCard,
  NoLocations
} from '#component/device/overview/styles';
import EventsCard from './events-card';
import MeasurementCard from './measurements-card';
import DialogWithMeasurements from './dialog-measurements';

const { VITE_MAPBOX_GLJS_API } = import.meta.env;
const EVENTS_TAB = 100;

function MobileView(props) {
  const {
    replaceHistoryParams,
    locationsLoading,
    identifiers,
    locations,
    account,
    device,
    events,
    meta,
    metrics,
    clickedDevices,
    setClickedDevices,
    clickedEvents,
    setClickedEvents
  } = props;

  const [open, setOpen] = useState(false);

  const presentMeasurements = useMemo(
    () => getLastExistingMeasurements(metrics, device, account, meta.device || []),
    [metrics, device, account, meta]
  );

  const lastLocation = locations[locations.length - 1];
  const { lat, lng } = lastLocation || {};

  const getCardWidth = () => {
    const windowWidth = window.innerWidth;

    // To understand check computed layout in chrome devtools
    const OUTER_DIVS_PADDING_SUM = 32;
    const TEN_PERCENTS_OF_FREE_SPACE = 0.1; // card width is 90%
    const CARD_TOTAL_MARGIN = (windowWidth - OUTER_DIVS_PADDING_SUM) * TEN_PERCENTS_OF_FREE_SPACE;

    const cardWidth = Math.ceil(windowWidth - OUTER_DIVS_PADDING_SUM - CARD_TOTAL_MARGIN);
    return cardWidth;
  };

  const staticMapSrc = `//api.mapbox.com/styles/v1/mapbox/light-v10/static/pin-s+000(${lng},${lat})/${lng},${lat},13/${getCardWidth()}x200?logo=false&access_token=${VITE_MAPBOX_GLJS_API}`;

  const handleClickOpen = tabNum => {
    setOpen(!open);
    replaceHistoryParams({
      tabNum
    });
  };

  const handleClose = () => {
    setOpen(!open);
  };

  return (
    <CardWrapper>
      <EventsCard
        handleOpen={() => handleClickOpen(EVENTS_TAB)}
        events={events}
      />
      {identifiers.map((identifier, index) =>
        <MeasurementCard
          presentMeasurements={presentMeasurements}
          identifier={identifier}
          key={identifier}
          device={device}
          index={index}
          handleOpen={() => handleClickOpen(index)}
        />)}
      <StyledCard onClick={() => handleClickOpen(90)}>
        {locationsLoading && <Preloader style={{ margin: '45px auto 0' }} />}
        {!locationsLoading &&
          (lastLocation ?
            <img alt="map" src={staticMapSrc} /> :
            <NoLocations>
              <Typography variant="h4">
                No locations
              </Typography>
            </NoLocations>)}
      </StyledCard>
      <DialogWithMeasurements handleClose={handleClose} open={open} {...props} />
      <DevicesDialog
        open={Boolean(clickedDevices.length)}
        isMobile={true}
        handleClose={setClickedDevices}
        clickedDevices={clickedDevices}
        loading={false}
      />
      <EventsListDialog
        open={Boolean(clickedEvents.length)}
        isMobile={true}
        handleClose={setClickedEvents}
        loading={false}
        {...props}
      />
    </CardWrapper>
  );
}

export default MobileView;
